import { useEffect, useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Vspace } from '../../components/styled/Separators.style'
import PageContainerCmp from "../PageContainerCmp";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { CommunicationType, EventCommType, EventValueEnum, LinearConducenteInfo, LinearContactInfo } from "../../types/communication/communicationDataType";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LErrorTxt, LPageTitle, LSimpleText } from "../../components/styled/Text.style";
import { LNextButton, SecondChoiseButton, } from "../../components/styled/Button.style";
import { Section } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { composeUrl } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import LinearConducenteCmp from "../../components/driver/LinearConducenteCmp";
import { CaiSideType, SignCaiBodyType } from "../../types/communication/sign-type";
import LoaderCmp from "../../components/loader/LoaderCmp";
const ERROR_MSG_VISIBILITY_TIME = 5000

const ResendCommunicationPageLinear = () => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const { communication, saveCommunicationMetadata } = communicationData
    const { token, linearConducenteInfo } = communication;
    const [showForwardError, setShowForwardError] = useState(false)

    const [conducenteInfo, setConducenteInfo] = useState<LinearConducenteInfo>(linearConducenteInfo)
    const [forwardRequested, setForwardRequested] = useState(false)

    /* istanbul ignore next */
    const goToNextStepHandler = () => {
        setForwardRequested(true)
        const nextPath = composeUrl(token, LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE, LINEAR_BASE_ROUTE)
        const newLinearConducenteInfo = {
            insuredIsDriver: false,
            conducente_contactInfo: new LinearContactInfo(conducenteInfo.conducente_contactInfo)
        }

        const vehicleA: CaiSideType = {
            ...communication?.caiData?.data?.vehicleA!,
            driver: {
                ...communication?.caiData?.data?.vehicleA?.driver!,
                name: newLinearConducenteInfo.conducente_contactInfo.name,
                surname: newLinearConducenteInfo.conducente_contactInfo.surname,
                telNumber: newLinearConducenteInfo.conducente_contactInfo.phoneNumber,
            },
        }

        const updatedCaiData: SignCaiBodyType = {
            ...communication?.caiData!,
            data: {
                ...communication?.caiData?.data,
                vehicleA
            },
        }

        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                linearConducenteInfo: newLinearConducenteInfo,
                caiData: updatedCaiData
            }),
            events: [new EventCommType({ value: EventValueEnum.LINEAR_DRIVER_INFO_SUBMITTED })],
            callback: () => navigate(nextPath)
        }))
    }

    const goToPreviousStepHandler = () => {
        const nextPath = composeUrl(token, LINEAR_PATHS.WELCOME_FIRST_PAGE, LINEAR_BASE_ROUTE)
        dispatch(saveCommunicationAct({
            events: [new EventCommType({ value: EventValueEnum.LINEAR_REFUSE_TO_SEND_COMMUNICATION })],
            callback: () => navigate(nextPath)
        }))
    }

    const isCaiStepValid = !!(
        conducenteInfo.insuredIsDriver === false &&
        (conducenteInfo?.conducente_contactInfo?.name &&
            conducenteInfo?.conducente_contactInfo?.surname &&
            conducenteInfo?.conducente_contactInfo?.phoneNumber)
    )

    useEffect(() => {
        // Manage login failure message
        let timeoutForwardErrorMsg: any;
        if (forwardRequested && saveCommunicationMetadata?.error) {
            setShowForwardError(true)
            timeoutForwardErrorMsg = setTimeout(() => {
                setShowForwardError(false)
            }, ERROR_MSG_VISIBILITY_TIME)
        }

        return () => {
            timeoutForwardErrorMsg && clearTimeout(timeoutForwardErrorMsg)
        }
    }, [saveCommunicationMetadata?.error, forwardRequested])

    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.RESEND_COMMUNICATION_PAGE}
                removeNextBtn
                isForceLastPathname={true}
            >
                {forwardRequested && saveCommunicationMetadata?.isLoading && <LoaderCmp className="cover cai-preview" />}

                <Section linear={true}>

                    <LPageTitle>INOLTRA COMUNICAZIONE</LPageTitle>
                    <Vspace qty={2}></Vspace>
                    <LSimpleText>Se non eri alla guida del tuo veicolo al momento del sinistro puoi inoltrare questa comunicazione al conducente.</LSimpleText>
                    <Vspace qty={2}></Vspace>
                    <LSimpleText>Ti ricordiamo che in questo caso sarà lui a completare il processo di firma digitale e tu non avrai più accesso a questa pagina.</LSimpleText>
                    <Vspace qty={2}></Vspace>

                    <LinearConducenteCmp
                        initValues={conducenteInfo}
                        onChange={(newInfo: Partial<LinearConducenteInfo>) => setConducenteInfo(currInfo => ({
                            ...currInfo,
                            ...newInfo
                        }))}
                    />

                    <Vspace qty={1}></Vspace>

                    {showForwardError && <LErrorTxt>Errore in fase di inoltro, riprova</LErrorTxt>}
                    <Vspace qty={2}></Vspace>
                    <LNextButton
                        disabled={!isCaiStepValid}
                        onClick={goToNextStepHandler}
                    >
                        INOLTRA LA COMUNICAZIONE
                    </LNextButton>

                    <Vspace qty={2}></Vspace>

                    <SecondChoiseButton linear={true} onClick={goToPreviousStepHandler}>Non voglio inoltrare la comunicazione</SecondChoiseButton>

                    <Vspace qty={2}></Vspace>

                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default ResendCommunicationPageLinear;